import { useEffect, useRef, useState, memo } from 'react';

const ImageLoadBlocker = memo(({ returnPercent = false, needOnlyIsReady, isLoadedCount = false }) => {
	//! Refs
	const requestRef = useRef();
	const displayPercentRef = useRef(0);
	const imagesLoadedRef = useRef(false);

	//! States
	const [realPercent, setRealPercent] = useState(0);
	const [displayPercent, setDisplayPercent] = useState(0);

	//! Track image loading
	useEffect(() => {
		let images = Array.from(document.images);

		if (isLoadedCount && isLoadedCount > 0 && isLoadedCount <= images.length) {
			images = images.slice(0, isLoadedCount);
		}

		let loadedCount = 0;

		if (images.length === 0) {
			setRealPercent(100);
			imagesLoadedRef.current = true;
			return;
		}

		const handleImageLoad = () => {
			loadedCount++;
			const percent = Math.round((loadedCount / images.length) * 100);
			setRealPercent(percent);
			if (loadedCount === images.length) {
				imagesLoadedRef.current = true;
			}
		};

		images.forEach((img) => {
			if (img.complete && img.naturalHeight !== 0) {
				handleImageLoad();
			} else {
				img.addEventListener('load', handleImageLoad);
				img.addEventListener('error', handleImageLoad);
			}
		});

		return () => {
			images.forEach((img) => {
				img.removeEventListener('load', handleImageLoad);
				img.removeEventListener('error', handleImageLoad);
			});
		};
	}, [isLoadedCount]);

	//! Animate displayPercent toward realPercent
	useEffect(() => {
		const animate = () => {
			const delta = realPercent - displayPercentRef.current;
			if (Math.abs(delta) < 1) {
				setDisplayPercent(realPercent);
				cancelAnimationFrame(requestRef.current);
				return;
			}

			displayPercentRef.current += delta * 0.1;
			const rounded = Math.round(displayPercentRef.current);
			setDisplayPercent(rounded);
			requestRef.current = requestAnimationFrame(animate);
		};

		requestRef.current = requestAnimationFrame(animate);
		return () => cancelAnimationFrame(requestRef.current);
	}, [realPercent]);

	//! Optional returnPercent callback
	useEffect(() => {
		if (needOnlyIsReady) {
			//! For Preloader Animation (speed)
			if (displayPercent >= 90) {
				returnPercent?.(displayPercent);
			}
		} else {
			returnPercent?.(displayPercent);
		}
	}, [displayPercent, returnPercent]);

	return null;
});

export default ImageLoadBlocker;
